import { CopyPublicLinkButton } from '@/components/public/copy-public-link-button'
import { ViewPublicLinkButton } from '@/components/public/view-public-link-button'

type PublicShareLinkActionsProps = {
  url: string
  viewLabel?: string
  copyLabel?: string
  /** Compact, icon-only buttons with hover tooltips (e.g. space-constrained page headers). */
  iconOnly?: boolean
}

/** View + copy affordances for managed detail pages linking to the public share URL. */
export function PublicShareLinkActions({
  url,
  viewLabel = 'View public page',
  copyLabel = 'Copy link',
  iconOnly = false,
}: PublicShareLinkActionsProps) {
  const href = url.trim()
  const disabled = !href

  return (
    <div className="flex flex-wrap items-center gap-2">
      <ViewPublicLinkButton url={href} label={viewLabel} iconOnly={iconOnly} disabled={disabled} />
      <CopyPublicLinkButton url={href} label={copyLabel} iconOnly={iconOnly} disabled={disabled} />
    </div>
  )
}
